import { IModal } from 'customTypes';
import { BtnBlue, BtnWhite } from '../Button';
import { ModalBackground, Modal } from '../../assets/styles/Modal';
import { SketchPicker } from 'react-color';
import { useState } from 'react';
import { FLAG_CREATE_OR_UPDATE } from '../../_constants';
import { useRecoilValue } from 'recoil';
import { IUser, userState } from '../../atoms';
import { useTranslation } from 'react-i18next';

interface Props {
  openModal: any;
  setOpenModal: any;
}

const ColorPickerModal = ({ openModal, setOpenModal }: any) => {
  const { t } = useTranslation();
  const userInfo = useRecoilValue<IUser>(userState);
  const [selectColor, setSelectColor] = useState(openModal.color || '#000');

  // 닫기버튼 클릭
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
    openModal.setColorState(openModal.color);
  };

  const onClickConfirm = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
    if (openModal.type === 'object') {
      if (openModal.colorType === 'bg') {
        openModal.el.backColor = selectColor;
      }
      if (openModal.colorType === 'font') {
        openModal.el.fontColor = selectColor;
      }
      const newObj = { ...openModal.el, sbdFontcolor: selectColor, flag: FLAG_CREATE_OR_UPDATE, editor: userInfo.userId };

      openModal.state[openModal.index] = newObj;
    }
    if (openModal.type === 'array') {
      // 색상 일괄적용
      const copyArray = [...openModal.state];
      const newArray = copyArray.map((el: any) => (el.checkedSbd ? { ...el, sbdFontcolor: selectColor, flag: FLAG_CREATE_OR_UPDATE, editor: userInfo.userId, checkedSbd: false } : { ...el }));
      openModal.setState(newArray);
    }
  };

  const handleChangeColor = (colorParam: any) => {
    setSelectColor(colorParam.hex);
    openModal.setColorState(colorParam.hex);
  };

  return (
    <ModalBackground>
      <Modal>
        <div className='modal color-picker-md'>
          <div className='inputForm-head'>
            <div className='modalHeaderTitle'>{t(`${openModal.tit ?? '폰트'} 색상을 클릭하세요`)}</div>
          </div>
          <div className='inputForm-body'>{openModal && openModal.title === 'colorPicker' && <SketchPicker color={selectColor} onChange={handleChangeColor} />}</div>
          <div className='modal-footer flex-end'>
            <BtnBlue onClick={onClickConfirm}>{t('확인')}</BtnBlue>
            <BtnWhite onClick={onClickClose}>{t('닫기')}</BtnWhite>
          </div>
        </div>
      </Modal>
    </ModalBackground>
  );
};

export default ColorPickerModal;
